export enum FeatureNames {
  SHOP = 'shop',
  MODEL_CREATION = 'model_creation',
  CONNECTED_SERVICES = 'connected_services',
  SERVICE_POINT = 'service_point',
  USER_REGISTRATION = 'UserRegistration',
  USER_REGISTRATION_FEATURE_KEY = 'user_registration',
  DEVICE_CREATION_FEATURE_KEY = 'device_creation',
  PRODUCT_SLECTION_TOOL_FEATURE_KEY = 'product_selection',
}

export enum ShopFeatures {
  ENABLED = 'enabled',
  LINK = 'link',
  NAME = 'name',
}

export enum ModelCreationFeatures {
  AUTO_CREATE_MODEL = 'autoCreateModel',
  AUTO_CREATE_MODEL_DETAIL = 'autoCreateModelDetail',
  NAME = 'name',
  REGEX = 'regex',
}

export enum ConnectedServicesFeatures {
  NAME = 'name',
  MONITORING_ENABLED = 'monitoringEnabled',
  ASSET_MANAGEMENT_ENABLED = 'assetManagementEnabled',
}

export enum ServicePointFeatures {
  APP_NAME = 'appName',
  APP_URL = 'appUrl',
  ASSET_IMAGE = 'assetImageEnabled',
  BRAND_NAME = 'brandName',
  CONTACT_EMAIL_SENDGRID_TEMPLATE_ID = 'contactEmailSendgridTemplateId',
  CONTACT_TILE = 'contactTileEnabled',
  CREATE_ACCOUNT_TILE = 'createAccountTileEnabled',
  DOCUMENTS_TILE = 'documentsTileEnabled',
  DOMAIN = 'domain',
  ECOPLANT_TILE = 'ecoplantTileEnabled',
  ELOQUA_BRAND_CODE = 'eloquaBrandCode',
  ELOQUA_TRANSFER_ENABLED_TILE = 'eloquaTransferEnabled',
  ENABLED = 'enabled',
  IMPRINT_URL = 'imprintUrl',
  INTERNAL_CONTACT_EMAIL = 'internalContactEmail',
  LOGIN_TILE = 'loginTileEnabled',
  MY_ASSETS_TILE = 'myAssetsEnabled',
  MARKETING_TILE = 'marketingTileEnabled',
  MARKETING_TILE_LINK = 'marketingTileURL',
  MARKETING_TILE_ICON = 'marketingTileIconName',
  MARKETING_TILE_TITLE = 'marketingTileText',
  NAME = 'name',
  NOTES_TILE = 'notesTileEnabled',
  PRICE_SPIDER = 'priceSpiderEnabled',
  PRICE_SPIDER_API_KEY = 'priceSpiderApiKey',
  PURCHASING_DEPARTMENT_EMAIL = 'purchasingDepartmentEmail',
  PURCHASING_DEPARTMENT_SENDGRID_TEMPLATE_ID = 'purchasingDepartmentSendgridTemplateId',
  SCAN_TILE = 'scanTileEnabled',
  SERIAL_NUMBER_SEARCH_TILE = 'serialNumberPageEnabled',
  SERVICE_DEPARTMENT_EMAIL = 'serviceDepartmentEmail',
  SERVICE_EMAIL_SENDGRID_TEMLATE_ID = 'serviceEmailSendgridTemplateId',
  SERVICES_TILE = 'servicesTileEnabled',
  SERVICES_FORM = 'servicesForm',
  SPARE_PART_TILE = 'sparePartTileEnabled',
  SPARE_PART_TILE_ICON_NAME = 'sparePartsTileIconName',
  SPARE_PART_CUSTOM_TILE = 'sparePartCustomTileEnabled',
  SPARE_PART_CUSTOM_TILE_TEXT = 'sparePartCustomTileText',
  TUBE_SETTINGS_TILE = 'tubeSettingsTileEnabled',
  WARRANTY_EXTENSION = 'warrantyExtensionTileEnabled',
  WARRANTY_EXTENSION_PERIOD = 'warrantyExtensionTilePeriod',
  WARRANTY_EXTENSION_TILE_VISIBLE_IF_ELIGIBLE = 'warrantyExtensionTileVisibleIfEligable',
  WARRANTY_EXTENSION_URL = 'warrantyExtensionTileUrl',
  WARRANTY_EXTENSION_FEATURE_ENABLED = 'warrantyExtensionEnabled',
  WEBSITE_TILE = 'websiteTileEnabled',
  VISIT_E_SHOP_TILE = 'visiteShopLinkEnabled',
  VISIT_SHOP_LINK = 'visiteShopLink',
}

export enum UserRegistration {
  name = 'user_registration',
  SELF_REGISTRATION_ENABLED = 'selfRegistrationEnabled',
}
